module.exports = __webpack_public_path__ + "img/New Customer.f483539c.svg";